import PropTypes from 'prop-types';
import {setDeletedUsers, updateDeletedUsers} from '../../app/actions';
import {connect} from '../../app/connect';
import {useEffect, useCallback} from 'react';
import ConstructionApi from '../../services/construction-api';
import {getAccessToken} from '../../app/selectors';

const fetchAndUpdateDeletedUsers = (deletedUsers, dispatch, {constructionApi}) => {
  const {limit, offset, totalResults} = deletedUsers.pagination;
  const promises = [];
  for (let i = 1; i < Math.ceil(totalResults / limit); i++) {
    promises.push(constructionApi.getDeletedProjectUsers({offset: offset + i * limit, limit}));
  }
  return Promise.all(promises).then(response => {
    response.forEach(data => {
      dispatch(updateDeletedUsers(data));
    });
  });
};

const DeletedUserFetcher = ({dispatch, accessToken, projectId}) => {
  const fetchDeletedUsers = useCallback(async () => {
    if (!accessToken) {
      return;
    }
    const constructionApi = new ConstructionApi(dispatch, accessToken);
    constructionApi.setConfig({projectId});
    constructionApi.getPaginatedDeletedUsersInProject().then(async data => {
      dispatch(setDeletedUsers(data.results));
      data.pagination && (await fetchAndUpdateDeletedUsers(data, dispatch, {constructionApi}));
    });
  }, [accessToken, dispatch, projectId]);

  useEffect(() => {
    fetchDeletedUsers();
  }, [fetchDeletedUsers]);

  return null;
};
const mapStateToProps = state => ({
  accessToken: getAccessToken(state)
});

DeletedUserFetcher.propTypes = {
  dispatch: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(DeletedUserFetcher);
